import { useTranslation } from 'react-i18next';
import { Row, day } from './bodyParts';

export interface StockTransferDetail {
  id: string;
  transferNumber: string;
  status: string;
  notes?: string | null;
  createdAt: string;
  shippedAt?: string | null;
  receivedAt?: string | null;
  fromLocation?: { name: string } | null;
  toLocation?: { name: string } | null;
  items: Array<{
    id: string;
    requestedQty: number;
    sentQty: number;
    receivedQty: number;
    product?: { name: string; sku?: string | null } | null;
  }>;
}

/** Read-only stock transfer for the record viewer (POS-I239). */
export function StockTransferDetailBody({ data }: { data: StockTransferDetail }) {
  const { t } = useTranslation('records');
  return (
    <div className="space-y-5 text-sm">
      <dl className="space-y-1.5">
        <Row label={t('rvDate')}><span dir="ltr">{day(data.createdAt)}</span></Row>
        {data.fromLocation?.name && <Row label={t('rvFrom')}>{data.fromLocation.name}</Row>}
        {data.toLocation?.name && <Row label={t('rvTo')}>{data.toLocation.name}</Row>}
        {data.shippedAt && <Row label={t('rvShipped')}><span dir="ltr">{day(data.shippedAt)}</span></Row>}
        {data.receivedAt && <Row label={t('rvReceivedAt')}><span dir="ltr">{day(data.receivedAt)}</span></Row>}
        {data.notes && <Row label={t('rvNotes')}>{data.notes}</Row>}
      </dl>
      {data.items.length === 0 ? (
        <p className="text-muted-foreground">{t('rvNoItems')}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b text-xs text-muted-foreground">
                <th className="py-1 text-start font-medium">{t('rvProduct')}</th>
                <th className="py-1 text-end font-medium">{t('rvRequested')}</th>
                <th className="py-1 text-end font-medium">{t('rvSent')}</th>
                <th className="py-1 text-end font-medium">{t('rvReceived')}</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((i) => (
                <tr key={i.id} className="border-b align-top last:border-0">
                  <td className="py-1.5 break-words">{i.product?.name}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.requestedQty}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.sentQty}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.receivedQty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
